import * as React from "react";
import PropTypes from 'prop-types';

const SvgHeart = props => {
  if (props.id !== "_svgheart") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 0 30 30" {...props}><g fill="none" fillRule="evenodd"><path d="M0 0h48v48H0z" /><path fill="#363E46" d="M19.3 7.7c1.1 0 2.2.5 3 1.3 1 1.1 1.6 2.5 1.6 4s-.5 3-1.5 4.1l-7 7.5c-.2.2-.4.3-.5.4 0 0-.2-.1-.4-.4l-7-7.5c-1.1-1.2-1.7-2.7-1.6-4.1 0-1.4.6-2.8 1.8-4 .8-.8 1.8-1.3 2.8-1.3 2 0 3.4 2.2 3.5 2.2l.9 1.5 1-1.4c-.1-.1 1.4-2.3 3.4-2.3m0-1.1c-2.6 0-4.4 2.7-4.4 2.7s-1.7-2.7-4.4-2.7c-1.3 0-2.7.6-3.7 1.6-1.2 1.3-2 2.9-2.1 4.8 0 1.8.8 3.6 1.9 4.9l7 7.5c.4.4.8.7 1.2.7s1-.4 1.4-.7l7-7.5c1.2-1.3 1.8-3 1.8-4.8 0-1.8-.8-3.5-2-4.8-.9-1.1-2.4-1.7-3.7-1.7" /></g></svg>;
};

SvgHeart.displayName = "_svgheart";
SvgHeart.propTypes = {
  id: PropTypes.string
};
SvgHeart.defaultProps = {
  id: ''
};
export default SvgHeart;